import styled, {createGlobalStyle} from 'styled-components';

export const GoogleMapContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const MapGlobalStyles = createGlobalStyle`
  /* GOOGLE MAPS STYLES FOR DETAILS */
  .pac-container {
    transform: translate(-2.2rem, 1.4rem);
    width: 100%;
  }

  /* don't show 'close' button since info window opens on mouseover */
  .gm-style-iw button {
    display: none!important;
  }
`;
